import * as React from 'react';
import Grid from '@mui/material/Grid';
import { Theme, Typography, IconButton } from '@mui/material';
import { WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import CloseIcon from '@mui/icons-material/Close';

interface OwnProps {
	description: string;
	value: string;
	variant?: 'subtitle2' | 'body2' | 'caption';
	color?: 'textPrimary' | 'textSecondary';
	onRemoveClick?: () => void;
	disabled?: boolean;
	dataQA?: string;
}

type Props = OwnProps & WithStyles<typeof styles>;

export const PaymentRow = ({
	classes,
	variant = 'body2',
	color = 'textPrimary',
	description,
	onRemoveClick,
	disabled,
	value,
	dataQA,
}: Props) => {
	const hasRemove = !!onRemoveClick;
	return (
		<Grid container spacing={0} alignContent="flex-start" alignItems="center" py={0.5}>
			<Grid item xs={5}>
				<Typography className={classes.description} variant={variant} color={color}>
					{description}
				</Typography>
			</Grid>
			<Grid item xs={hasRemove ? 5 : 7}>
				<Typography
					className={classes.normalLineHeight}
					align={'right'}
					variant={variant}
					color={color}
					component="p"
					data-qa={dataQA}
				>
					{value}
				</Typography>
			</Grid>
			{hasRemove && (
				<Grid item xs={2}>
					<IconButton size="small" onClick={onRemoveClick!} disabled={!!disabled}>
						<CloseIcon />
					</IconButton>
				</Grid>
			)}
		</Grid>
	);
};

const styles = (theme: Theme) =>
	createStyles({
		normalLineHeight: {
			lineHeight: 1,
		},
		description: {
			lineHeight: 1,
		},
	});

export default withStyles(styles)(PaymentRow);
